
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/ee-footer.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-ee-footer-demo-ee-footer","docs-power-design-ee-footer-demo-dark"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/ee-footer.md?type=demo')
};